/**
 * Order Tabs
 *
 * @version
 * 4.71.0 OAUI-694 Final UI tweaks and finishing touches
 * 4.71.0 OAUI-685 Implement tabbed sections on table
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2024 Build Centrix
 */
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { WdLocalSharedFunctionsService } from '../../../../../services/shared/wd-local-shared-functions.service';
import { WdOrdersV2Service } from '../../../../../services/orders/wd-orders-v2.service';
import { WdLocalEnvironmentService } from '../../../../../services/environment/wd-local-environment.service';

@Component({
  selector: 'app-orders-list-tabs-component',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ListTabsComponent {
  /**
   * Constructor Initialization
   * @since 4.71.0
   */
  constructor(
    public wdEnvironmentService: WdLocalEnvironmentService,
    public wdLocalSharedFunctions: WdLocalSharedFunctionsService,
    public wdOrdersService: WdOrdersV2Service,
  ) {}

  // Order Type (Defaults to work orders)
  @Input() orderType: string = this.wdLocalSharedFunctions.orderTypeKey.WORK;
}
